module.exports = __webpack_public_path__ + "static/img/75a2.e859df1.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/news/75a2.jpg
// module id = hd0e
// module chunks = 1